import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import 'css!./__styles__/EditHelpMessage';

type Props = {
  children: React.ReactNode;
};

const EditHelpMessage = (props: Props) => {
  return (
    <Typography2 component="p" variant="bodySecondary" className="rc-EditHelpMessage">
      {props.children}
    </Typography2>
  );
};

export default EditHelpMessage;
